module.exports = __webpack_public_path__ + "static/media/signal-4.85620f1e.svg";